import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import React from 'react';
import { FindListItem } from '../../types/find-list-item.interface';
import Button from '../button/button.component';

type Props = {
  finds: FindListItem[];
  prev?: FindListItem;
  next?: FindListItem;
};

const FindsTableComponent: React.FC<Props> = ({ finds, prev, next }) => {
  const router = useRouter();
  return (
    <table style={{ width: '100%' }}>
      <thead>
        <tr>
          <th>Inventory number</th>
          <th>Site Id</th>
          <th>Season</th>
          <th>Trench number</th>
          <th>Locus number</th>
          <th>Object Id</th>
          <th>Material</th>
          <th>Dating</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {finds.map((find, i) => (
          <tr key={find.id}>
            <td>
              <span className="mobileLabel">Inventory number</span>
              {find.inventoryNumber}
            </td>
            <td>
              <span className="mobileLabel">
                Site Id
              </span>
              {find.siteId}
            </td>
            <td>
              <span className="mobileLabel">
                Season
              </span>
              {find.season}
            </td>
            <td>
              <span className="mobileLabel">
                Trench number
              </span>
              {find.trenchNumber}
            </td>
            <td>
              <span className="mobileLabel">
                Locus number
              </span>
              {find.locusNumber}
            </td>
            <td>
              <span className="mobileLabel">Object Id</span>
              {find.objectId}
            </td>
            <td>
              <span className="mobileLabel">Material</span>
              {find.material}
            </td>
            <td>
              <span className="mobileLabel">Dating</span>
              {find.datingAbsolute}
            </td>
            <td>
              <Button
                small={true}
                btn={true}
                onClick={() => {
                  router.push({
                    pathname: `/finds/${find.id}`,
                    query: {
                      prev: String(i !== 0 ? finds[i - 1].id : prev?.id),
                      next: String(
                        i !== finds.length - 1 ? finds[i + 1].id : next?.id
                      ),
                      ...router.query,
                    },
                  });
                }}
                css={{ width: '50px' }}
              >
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default FindsTableComponent;
